import { Wand2 } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-sage-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="text-center text-sage-300">
          <p>&copy;{currentYear} AltTextWizard. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};